import React, { useEffect, useState } from "react";
import imageExists from "image-exists";
import PropTypes from "prop-types";
import { Part } from "models/Part";
import { partImagesRoot } from "constants/config";

import "./PartImage.css";

const PartImage = ({ part, smallScreen }) => {
  const [imageReady, setImageReady] = useState(false);

  const getImageId = () => (part ? part.imageId : "null");
  const getImageSource = (suffix = "") =>
    `${partImagesRoot}/${getImageId()}${suffix}.jpg`;

  const checkImage = () => {
    imageExists(getImageSource(), (exists) => {
      setImageReady(exists);
    });
  };

  useEffect(() => {
    checkImage();
  }, [part]);

  const partCaption = part ? part.partNo : "";
  const vertical = smallScreen && part && part.isOpaqueKit();

  console.log("PartImage render", part, getImageSource());

  return imageReady ? (
    [
      <img
        src={vertical ? getImageSource("-vert") : getImageSource()}
        alt=""
        key="img"
        className={`img-responsive ${vertical ? "vertical" : ""}`}
      />,
      <p key={partCaption} style={{ display: part ? "block" : "none" }}>
        {partCaption}
      </p>,
    ]
  ) : (
    <div className="image-placeholder">
      <p>{partCaption}</p>
    </div>
  );
};

PartImage.defaultProps = {
  caption: "",
  part: null,
  smallScreen: false,
};

PartImage.propTypes = {
  caption: PropTypes.string,
  part: PropTypes.instanceOf(Part),
  smallScreen: PropTypes.bool,
};

export default PartImage;
